<template>
  <el-dialog :title="'Selecionar Conta'" @open="iniciar" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body width="700px" v-loading="loading">
    <el-form ref="form" size="small" label-position="top" hide-required-asterisk	:show-message="false" style="padding:0;">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Nome">
            <el-input v-model="nomeContaFiltro"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12" style="padding: 0px 60px 0px 0px">
          <el-row type="flex" justify="end">
            <el-form-item label="Status Conta">
              <el-row>
                <el-radio v-model="statusContaFiltro" label="ATIVO">Ativa</el-radio>
              </el-row>
              <el-row>
                <el-radio v-model="statusContaFiltro" label="todas">Todas</el-radio>
              </el-row>
            </el-form-item>
          </el-row>
        </el-col>
      </el-row>

      <el-row type="flex" justify="end" style="margin: 5px 0px">
        <strong style="font-size: 12px">
          {{ labelQuantidadeContas }}
        </strong>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-table
            :data="contasBancariasFiltradas"
            empty-text="Nenhum item encontrado"
            size="small"
            height="150"
            style="background-color: #FFFFFF; "
            stripe
            highlight-current-row
            @row-click="selecionarContaBancaria"
            @row-dblclick="fechar">
            <el-table-column label="Banco" prop="banco" sortable show-overflow-tooltip width="100" :formatter="getLabelBanco"/>
            <el-table-column label="Titular" v-if="cliente || fornecedor" prop="titular" min-width="100"/>
            <el-table-column label="Nome" v-else prop="nome" sortable show-overflow-tooltip min-width="100"/>
            <el-table-column label="Agencia" prop="agencia" sortable show-overflow-tooltip width="90"/>
            <el-table-column label="Conta" prop="conta" sortable show-overflow-tooltip width="80"/>
            <el-table-column label="Operação" prop="operacao" sortable show-overflow-tooltip width="90"/>
            <el-table-column label="Pix" prop="pix" show-overflow-tooltip width="80" />
            <el-table-column label="Status" prop="status" width="80" sortable show-overflow-tooltip :formatter="getLabelStatusConta"/>
          </el-table>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer">
      <el-button type="primary" size="small" @click="fechar" round class="btn-box-shadow">Selecionar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import funcoes from '../../util/funcoes.js';
import { BANCOS, STATUS_CONTA, BANCOS_HOMOLOGADOS, BANCOS_HOMOLOGADOS_API } from '../../util/constantes.js';

export default {
  props: {
    cliente: Object,
    fornecedor: Object, 
    usuario: Object,
    apenasBancosHomologados: {
      type: Boolean,
      default: false,
    },
    todosOsBancos: {
      type: Boolean,
      default: false
    },
    isRegistroApi: {
      type: Boolean,
      default: false
    },
    visibility: Boolean,
  },

  data() {
    return {
      loadingContasBancarias: false,
      contasBancariasDisponiveis: [],
      contaBancariaSelecionada: {
        id: 0,
        nome: ''
      },
      nomeContaFiltro: '',
      statusContaFiltro: 'ATIVO',
    }
  },

  computed: {
    contasBancariasFiltradas() {
      return this.isRegistroApi ? 

      this.contasBancariasDisponiveis
        .filter(item => {
          if(BANCOS_HOMOLOGADOS_API.includes(item.banco)) {
            return item;
          }
        })
        .filter(this.filtroPorNome)
        .filter(this.filtroPorStatus)
        .filter(this.filtroPorHomologacao)

      :
      
      this.todosOsBancos ?
      
      this.contasBancariasDisponiveis
        .filter(this.filtroPorNome)
        .filter(this.filtroPorStatus)
        .filter(this.filtroPorHomologacao)
      :

      this.contasBancariasDisponiveis
        .filter(item => {
          if(!BANCOS_HOMOLOGADOS_API.includes(item.banco)) {
            return item;
          }
        })
        .filter(this.filtroPorNome)
        .filter(this.filtroPorStatus)
        .filter(this.filtroPorHomologacao);
    },
    labelQuantidadeContas() {
      const quantidade = this.contasBancariasFiltradas.length;

      switch(quantidade) {
        case 0:
          return "Nenhuma Conta encontrada";
        case 1:
          return "1 Conta encontrada";
        default:
          return `${quantidade} Contas encontradas`;
      }
    },
    bancos() {
      return BANCOS
    },
    statusConta() {
      return STATUS_CONTA
    },
    loading() {
      return this.$store.state.loading;
    }    
  },

  methods: {
    ...mapActions([
        'showLoading',
        'hideLoading'
    ]),
    ...mapActions('contasBancariasStore', [
        'listarContas'
    ]),
    filtroPorNome(conta) {
      if(conta && conta.nome){
        return conta.nome.toLowerCase().indexOf(this.nomeContaFiltro.toLowerCase()) != -1;
      } else {
        return true
      }
    },
    filtroPorStatus(conta) {
      if(conta && conta.status){
        return this.statusContaFiltro === "todas" ? true : conta.status === this.statusContaFiltro;
      } else {
        return true
      }
    },

    filtroPorHomologacao(conta) {
      if(this.apenasBancosHomologados) {
        const bancosHomologados = BANCOS_HOMOLOGADOS.map(object => object.data).filter(banco => banco !== '');

        return bancosHomologados.includes(conta.banco);
      }
      
      return true;
    },

    iniciar() {
      this.listarContasBancariasHandler()
      this.contaBancariaSelecionada = {
        id: 0,
        nome: ''
      }
    },
    listarContasBancariasHandler() {
        let payload = {}
        if(this.cliente || this.fornecedor || this.usuario){
          payload = this.cliente ? { cliente: { id: this.cliente.id } } : this.fornecedor ? {fornecedor: { id: this.fornecedor.id }} : {usuario: {id: this.usuario.id}}
        }

        this.showLoading();
        this.listarContas(payload)
        .then((resultado) => {
            this.hideLoading();
            switch(resultado.status) {
                case "SUCESSO":
                    this.contasBancariasDisponiveis = resultado.lista
                    break;
                case "FALHA":
                    this.$message.warning(resultado.mensagem);
                    break;
                default:
                    this.$message.error(resultado.mensagem);
                    break;
            }
        }).catch(() => {
            this.hideLoading();
        });
    },
    selecionarContaBancaria(row) {
      this.contaBancariaSelecionada = row
    },
    
    // UTIL
    getLabelContaSelecionada(){
      return `${this.getLabelBanco(this.bancos, this.contaBancariaSelecionada)} - Conta: ${this.contaBancariaSelecionada.conta}`; 
    },
    getLabelBanco(item) {
      return funcoes.getLabel(this.bancos,item.banco);
    },
    getLabelStatusConta(item) {
      return funcoes.getLabel(this.statusConta,item.status)
    },
    fechar() {
      this.$emit('close',this.contaBancariaSelecionada);
    }
  }
}
</script>
